import { NgModule } from '@angular/core';
import { LocalizationModule } from '../localization';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { CommonModule } from '@angular/common';
import { WidgetFactoryService } from './services/widget-factory.service';
import { ChassisModalModule } from '../modals';
import { ChassisAlertModule } from '../alerts';
import { SupportModule } from '../support/support.module';
import { DashboardService } from './services/dashboard.service';
import { WidgetService } from './services/widget.service';
import { TableListComponent } from './components/table-list/table-list.component';

@NgModule({
    imports: [
        CommonModule,
        LocalizationModule,
        NgxDnDModule,
        ChassisModalModule,
        ChassisAlertModule,
        SupportModule,
    ],
    declarations: [
        TableListComponent,
    ],
    entryComponents: [
        TableListComponent,
    ],
    providers: [
        WidgetFactoryService,
        DashboardService,
        WidgetService,
    ],
    exports: [
        CommonModule,
        LocalizationModule,
        NgxDnDModule,
        ChassisModalModule,
        ChassisAlertModule,
        SupportModule,
        TableListComponent,
    ],
})
export class ChassisDashboardsBootstrapModule {

    constructor(protected widgetFactory: WidgetFactoryService) {

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/dashboards-bootstrap.module.ts